import React from 'react';
import { Link } from 'react-router-dom';
import { MailIcon } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-[#0C1B26] text-white pt-12 pb-6" data-id="element-622">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-623">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8" data-id="element-624">
          {/* Company Info */}
          <div data-id="element-625">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6QmLb9SHG8EWoZXcAsBKy5/Header_Bright_Pixxel_Logo_.png" alt="Bright Pixxel Studio" className="h-14 mb-4" data-id="element-626" />
            <p className="text-white/70 text-sm mb-4" data-id="element-627">
              UK-based web design, e-commerce, and SEO services. Creating
              beautiful, high-performing websites that drive results.
            </p>
            <a href="mailto:info@bright-pixxel.com" className="flex items-center text-white/70 hover:text-[#0DC3DC] transition-colors text-sm mb-2" data-id="element-628">
              <MailIcon size={16} className="mr-2" data-id="element-629" />
              info@bright-pixxel.com
            </a>
            <a href="https://wa.me/447000000000" className="flex items-center text-white/70 hover:text-[#0DC3DC] transition-colors text-sm" target="_blank" rel="noopener noreferrer" data-id="element-630">
              <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 24 24" data-id="element-631">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 0 0-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z" data-id="element-632" />
              </svg>
              WhatsApp Us
            </a>
          </div>
          {/* Services */}
          <div data-id="element-633">
            <h3 className="text-lg font-bold mb-4" data-id="element-634">Services</h3>
            <ul className="space-y-2" data-id="element-635">
              <li data-id="element-636">
                <Link to="/services/web-design" className="text-white/70 hover:text-[#0DC3DC] transition-colors text-sm" data-id="element-637">
                  Web Design
                </Link>
              </li>
              <li data-id="element-638">
                <Link to="/services/ecommerce" className="text-white/70 hover:text-[#0DC3DC] transition-colors text-sm" data-id="element-639">
                  E-Commerce
                </Link>
              </li>
              <li data-id="element-640">
                <Link to="/services/branding" className="text-white/70 hover:text-[#0DC3DC] transition-colors text-sm" data-id="element-641">
                  Branding
                </Link>
              </li>
              <li data-id="element-642">
                <Link to="/services/seo" className="text-white/70 hover:text-[#0DC3DC] transition-colors text-sm" data-id="element-643">
                  SEO Services
                </Link>
              </li>
              <li data-id="element-644">
                <Link to="/services/maintenance" className="text-white/70 hover:text-[#0DC3DC] transition-colors text-sm" data-id="element-645">
                  Website Maintenance
                </Link>
              </li>
            </ul>
          </div>
          {/* Company */}
          <div data-id="element-646">
            <h3 className="text-lg font-bold mb-4" data-id="element-647">Company</h3>
            <ul className="space-y-2" data-id="element-648">
              <li data-id="element-649">
                <Link to="/about" className="text-white/70 hover:text-[#0DC3DC] transition-colors text-sm" data-id="element-650">
                  About Us
                </Link>
              </li>
              <li data-id="element-651">
                <Link to="/portfolio" className="text-white/70 hover:text-[#0DC3DC] transition-colors text-sm" data-id="element-652">
                  Portfolio
                </Link>
              </li>
              <li data-id="element-653">
                <Link to="/pricing" className="text-white/70 hover:text-[#0DC3DC] transition-colors text-sm" data-id="element-654">
                  Pricing
                </Link>
              </li>
              <li data-id="element-655">
                <Link to="/faq" className="text-white/70 hover:text-[#0DC3DC] transition-colors text-sm" data-id="element-656">
                  FAQ
                </Link>
              </li>
              <li data-id="element-657">
                <Link to="/contact" className="text-white/70 hover:text-[#0DC3DC] transition-colors text-sm" data-id="element-658">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
          {/* Legal */}
          <div data-id="element-659">
            <h3 className="text-lg font-bold mb-4" data-id="element-660">Legal</h3>
            <ul className="space-y-2" data-id="element-661">
              <li data-id="element-662">
                <Link to="/privacy" className="text-white/70 hover:text-[#0DC3DC] transition-colors text-sm" data-id="element-663">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-664">
                <Link to="/terms" className="text-white/70 hover:text-[#0DC3DC] transition-colors text-sm" data-id="element-665">
                  Terms & Conditions
                </Link>
              </li>
              <li data-id="element-666">
                <Link to="/cancellation" className="text-white/70 hover:text-[#0DC3DC] transition-colors text-sm" data-id="element-667">
                  Cancellation Policy
                </Link>
              </li>
              <li data-id="element-668">
                <Link to="/policies" className="text-white/70 hover:text-[#0DC3DC] transition-colors text-sm" data-id="element-669">
                  All Policies
                </Link>
              </li>
            </ul>
          </div>
        </div>
        {/* Bottom Bar */}
        <div className="pt-6 border-t border-white/10" data-id="element-670">
          <p className="text-white/70 text-sm text-center" data-id="element-671">
            © {currentYear} Bright Pixxel Studio. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}